<template>
  <div class="app-container">
    <el-alert
      title="分别管理公司军校、部门军校和皮科研修院的三级分类。启用分类用于学员首页导航，不绑定权限；具体场景权限在场景管理的“授权”弹窗设置。"
      type="info"
      :closable="false"
      class="mb10"
    />
    <el-tabs v-model="activeSchoolType" @tab-click="handleTabChange">
      <el-tab-pane v-for="t in schoolTypes" :key="t.value" :label="t.label" :name="String(t.value)" />
    </el-tabs>

    <el-card class="box-card" v-loading="loading">
      <div class="btn-right-side mb10">
        <el-button type="primary" size="mini" icon="el-icon-plus" @click="handleCreate(null)" v-hasPermi="['aiTrain:category:add']">
          新建一级分类
        </el-button>
      </div>

      <el-tree
        v-if="treeData.length"
        :data="treeData"
        node-key="id"
        :props="{ children: 'children', label: 'name' }"
        default-expand-all
        draggable
        @node-drop="handleDrop"
      >
        <span class="tree-node" slot-scope="{ node, data }">
          <span>
            {{ data.name }}
            <el-tag size="mini" :type="data.state === 1 ? 'success' : 'info'">{{ data.state === 1 ? '启用' : '禁用' }}</el-tag>
            <el-tag size="mini" type="info" plain>L{{ data.level }}</el-tag>
          </span>
          <span class="tree-node-actions">
            <el-button type="text" size="mini" v-if="data.level < 3" @click="handleCreate(data)" v-hasPermi="['aiTrain:category:add']">新建子级</el-button>
            <el-button type="text" size="mini" @click="handleEdit(data)" v-hasPermi="['aiTrain:category:edit']">编辑</el-button>
            <el-button type="text" size="mini" @click="handleToggleState(data)" v-hasPermi="['aiTrain:category:edit']">
              {{ data.state === 1 ? '禁用' : '启用' }}
            </el-button>
            <el-button type="text" size="mini" style="color:#f56c6c" @click="handleDelete(data)" v-hasPermi="['aiTrain:category:delete']">删除</el-button>
          </span>
        </span>
      </el-tree>
      <el-empty v-else description="暂无分类，点击右上角新建" />
    </el-card>

    <el-dialog :title="form.id ? '编辑分类' : '新建分类'" :visible.sync="dialogVisible" width="480px" :close-on-click-modal="false">
      <el-form ref="dataForm" :model="form" :rules="formRules" label-width="90px" size="small">
        <el-form-item label="所属板块">
          <el-input :value="schoolTypeLabel(form.schoolType)" disabled />
        </el-form-item>
        <el-form-item label="上级分类">
          <el-input :value="form.parentName || '（一级）'" disabled />
        </el-form-item>
        <el-form-item label="分类名称" prop="name">
          <el-input v-model="form.name" placeholder="请输入分类名称" maxlength="32" show-word-limit />
        </el-form-item>
        <el-form-item label="排序" prop="sort">
          <el-input-number v-model="form.sort" :min="0" :max="9999" />
        </el-form-item>
        <el-form-item label="状态">
          <el-radio-group v-model="form.state">
            <el-radio :label="1">启用</el-radio>
            <el-radio :label="0">禁用</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" :loading="saving" @click="submitForm">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { treeRows } from '@/utils/ai-train-data'
import aiTrainCategoryApi from '@/api/aiTrain/category'

export default {
  name: 'AiTrainCategory',
  data() {
    return {
      schoolTypes: [
        { value: 1, label: '公司军校' },
        { value: 2, label: '部门军校' },
        { value: 3, label: '皮科研修院' }
      ],
      activeSchoolType: '1',
      loading: false,
      treeData: [],
      dialogVisible: false,
      saving: false,
      form: this.emptyForm(),
      formRules: {
        name: [{ required: true, message: '请输入分类名称', trigger: 'blur' }]
      }
    }
  },
  created() {
    this.loadTree()
  },
  methods: {
    emptyForm() {
      return { id: null, parentId: 0, parentName: '', schoolType: 1, name: '', sort: 0, state: 1, level: 1 }
    },
    schoolTypeLabel(v) {
      const t = this.schoolTypes.find(i => i.value === v)
      return t ? t.label : '-'
    },
    handleTabChange() {
      this.loadTree()
    },
    loadTree() {
      this.loading = true
      const schoolType = Number(this.activeSchoolType)
      return aiTrainCategoryApi.fetchTree(schoolType)
        .then(res => {
          const data = (res && res.data) || res || []
          this.treeData = treeRows(data)
        })
        .catch(() => {
          this.treeData = []
        })
        .finally(() => { this.loading = false })
    },
    handleCreate(parent) {
      this.form = this.emptyForm()
      this.form.schoolType = Number(this.activeSchoolType)
      if (parent) {
        this.form.parentId = parent.id
        this.form.parentName = parent.name
        this.form.level = (parent.level || 1) + 1
      }
      this.dialogVisible = true
      this.$nextTick(() => this.$refs.dataForm && this.$refs.dataForm.clearValidate())
    },
    handleEdit(row) {
      this.form = { ...this.emptyForm(), ...row }
      this.dialogVisible = true
      this.$nextTick(() => this.$refs.dataForm && this.$refs.dataForm.clearValidate())
    },
    submitForm() {
      this.$refs.dataForm.validate(valid => {
        if (!valid) return
        this.saving = true
        const api = this.form.id ? aiTrainCategoryApi.update(this.form) : aiTrainCategoryApi.create(this.form)
        api.then(() => {
          this.$message.success('保存成功')
          this.dialogVisible = false
          this.loadTree()
        }).catch(() => {}).finally(() => { this.saving = false })
      })
    },
    handleToggleState(row) {
      const next = row.state === 1 ? 0 : 1
      aiTrainCategoryApi.setState(row.id, next).then(() => {
        this.$message.success('操作成功')
        this.loadTree()
      })
    },
    handleDelete(row) {
      if (row.children && row.children.length) {
        this.$message.warning('请先删除子分类')
        return
      }
      this.$common.confirm('是否确认删除该分类？').then(() => aiTrainCategoryApi.deleteById(row.id))
        .then(() => {
          this.$message.success('删除成功')
          this.loadTree()
        })
    },
    handleDrop(draggingNode, dropNode, dropType) {
      // 拖拽排序：把同级节点按当前顺序回写 sort，交给后端按数组顺序批量更新
      const siblings = dropNode.parent.childNodes.map((n, idx) => ({ id: n.data.id, sort: idx }))
      aiTrainCategoryApi.sort({ items: siblings }).then(() => {
        this.$message.success('排序已更新')
      }).finally(() => this.loadTree())
    }
  }
}
</script>

<style scoped>
.tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding-right: 8px;
}
.tree-node-actions {
  white-space: nowrap;
}
.mb10 { margin-bottom: 10px; }
</style>
